module.exports = __webpack_public_path__ + "img/chr-logo.c5106429.png";